import _slicedToArray from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/logo128.png';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1dbc906a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "header"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont icon-duoyuyan"
  }, null, -1);
});
var _hoisted_3 = {
  class: "center"
};
var _hoisted_4 = {
  class: "logo",
  id: "passport-login-logo"
};
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var _hoisted_6 = {
  class: "content"
};
var _hoisted_7 = {
  class: "footer",
  id: "passport-login-footer"
};
var _hoisted_8 = {
  class: "left"
};
var _hoisted_9 = {
  key: 0,
  target: "_blank",
  href: "https://beian.miit.gov.cn/",
  rel: "noopener"
};
var _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-center\" data-v-1dbc906a><div class=\"ISO1\" data-v-1dbc906a></div><div class=\"ISO2\" data-v-1dbc906a></div><div class=\"ISO3\" data-v-1dbc906a></div><div class=\"ISO4\" data-v-1dbc906a></div></div>", 1);
import contactUs from '@/components/contact/index.vue';
import langWrapper from '@/components/pub/lang.vue';
import { useLang } from '@/hooks/lang';
import _get from 'lodash/get';
import { onUnmounted } from 'vue';
import { VueCookieNext } from 'vue-cookie-next';
import { useStore } from 'vuex';
import { SOFTWAREFLAG } from '@/utils/config';
export default {
  setup: function setup(__props) {
    var _useLang = useLang(),
      $t = _useLang.$t;
    var contactUsRef = ref(null);
    var store = useStore();
    var cc = ref(VueCookieNext.getCookie('cc'));
    var contentProviderText = _get(store, 'state.global.InternetContentProvider');
    var _sessionStorage$getIt = sessionStorage.getItem(SOFTWAREFLAG).split('_'),
      _sessionStorage$getIt2 = _slicedToArray(_sessionStorage$getIt, 1),
      soft = _sessionStorage$getIt2[0];
    store.commit('setThemeColor', soft + ' SOFTWARE');

    // 联系我们
    var contactUsChange = function contactUsChange() {
      contactUsRef.value.getInfo();
      contactUsRef.value.dialogVisible = true;
    };
    function readAgreement(params) {
      switch (params) {
        case 'privacyPolicy':
          store.commit('setPrivacyPolicy');
          break;
        case 'termsOfUse':
          store.commit('setTermsOfUse');
          break;
        default:
          break;
      }
    }
    var orientation = ref('landscape');
    var resize = function resize() {
      var _window$matchMedia;
      // 匹配到横屏模式 或者 屏幕宽度超过600 均采用横屏样式
      if (((_window$matchMedia = window.matchMedia('(orientation: portrait)')) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.matches) === false || window.innerWidth > 600) {
        orientation.value = 'landscape';
      } else {
        orientation.value = 'portrait';
      }
    };
    resize();
    window.addEventListener('resize', resize);
    onUnmounted(function () {
      window.removeEventListener('resize', resize);
    });
    return function (_ctx, _cache) {
      var _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["user-page", [orientation.value]])
      }, [_createElementVNode("div", _hoisted_1, [_createVNode(langWrapper, {
        class: "lang-option"
      }, {
        default: _withCtx(function () {
          return [_hoisted_2];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", null, _toDisplayString(_unref($t)("home.passportTitle")), 1)]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_router_view)])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [cc.value === 'CN' ? (_openBlock(), _createElementBlock("a", _hoisted_9, _toDisplayString(_unref(contentProviderText)), 1)) : _createCommentVNode("", true), _createElementVNode("span", {
        class: "contact",
        onClick: contactUsChange
      }, _toDisplayString(_unref($t)("app-login.contactUs")), 1), _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return readAgreement('privacyPolicy');
        })
      }, _toDisplayString(_unref($t)("app-login.privacyPolicy")), 1), _createElementVNode("span", {
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return readAgreement('termsOfUse');
        })
      }, _toDisplayString(_unref($t)("app-login.termsOfUse")), 1)]), _hoisted_10]), _createVNode(contactUs, {
        ref_key: "contactUsRef",
        ref: contactUsRef
      }, null, 512)], 2);
    };
  }
};